import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import SearchField from "../SearchField/SearchField";
import Divider from "@mui/material/Divider";
import { useTheme } from "@mui/material/styles";
import TablePagination from "@mui/material/TablePagination";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { Component } from "react";
import Moment from "react-moment";
import { Grid } from "@mui/material";
import TableFooter from "@mui/material/TableFooter";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
// import './DataTable.css'



function createData(
  item,
  orderID,
  bookDetails,
  date,
  amount,
  buyerID,
  status,
  image,
  author,
  stripeID,
  tlbcEarns,
  authorEarns,
  AuthorStatus,
  Amount,
  bookAmount,
  clearingAmount,
  currency,
  dollarRate,
  Reference_No,
  Status,
  paymentMethod,
  shipping_method,
  shipping_charges
) {
  return {
    item,
    orderID,
    bookDetails,
    date,
    amount,
    buyerID,
    status,
    image,
    author,
    stripeID,
    tlbcEarns,
    authorEarns,
    history: [
      {
        date: "2020-01-05",
        customerId: "11091700",
        amount: 3,
      },
      {
        date: "2020-01-02",
        customerId: "Anonymous",
        amount: 1,
      },
    ],
    AuthorStatus,
    Amount,
    bookAmount,
    clearingAmount,
    currency,
    dollarRate,
    Reference_No,
    Status,
    paymentMethod,
    shipping_method,
    shipping_charges
  };
}

function Row(props) {
  const { row, onUpdateDeliveryStatus } = props;

  const [open, setOpen] = React.useState(false);

  console.log('NewRow', row)
  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>
          {row.orderID}
        </TableCell>
        <TableCell>
          {(() => {
            // Check if this is a grouped paperback order with multiple items
            const isGroupedOrder = row.item?.items && Array.isArray(row.item.items) && row.item.items.length > 1;

            if (isGroupedOrder) {
              const items = row.item.items;
              const maxDisplay = 3;
              const displayItems = items.slice(0, maxDisplay);
              const remainingCount = items.length - maxDisplay;

              return (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                  {displayItems.map((item, index) => {
                    const bookName = item?.paperback?.Name || item?.book?.Name || '';
                    const quantity = parseInt(item?.quantity || 1);
                    return (
                      <Typography
                        key={index}
                        variant="body2"
                        sx={{
                          fontSize: '12px',
                          fontWeight: index === 0 ? 'bold' : 'normal',
                          color: index === 0 ? 'inherit' : '#666'
                        }}
                      >
                        {bookName} {quantity > 1 ? `(x${quantity})` : ''}
                      </Typography>
                    );
                  })}
                  {remainingCount > 0 && (
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: '12px',
                        color: '#1976d2',
                        fontStyle: 'italic',
                        fontWeight: 'bold'
                      }}
                    >
                      {remainingCount} more book{remainingCount > 1 ? 's' : ''}
                    </Typography>
                  )}
                </Box>
              );
            } else {
              // Single book or non-paperback order
              return row.bookDetails;
            }
          })()}
        </TableCell>
        <TableCell>
          <Moment format="DD-MM-YYYY HH:mm">{row.date}</Moment>
        </TableCell>
        <TableCell>{
          (() => {
            // Paperback orders - only PKR, no USD conversion
            // Amount = Book Price + Shipping Charges
            const isGroupedOrder = row.item?.items && Array.isArray(row.item.items) && row.item.items.length > 1;

            if (isGroupedOrder) {
              // For grouped orders, calculate total from all items
              const totalBookAmount = row.item.totalBookAmount || row.item.items.reduce((sum, itm) => {
                const price = parseFloat(itm?.paperback?.Price || itm?.book?.Price || 0);
                const quantity = parseInt(itm?.quantity || 1);
                return sum + (price * quantity);
              }, 0);
              const shippingCharges = parseFloat(row.shipping_charges || 0);
              return (totalBookAmount + shippingCharges).toFixed(2) + ' PKR';
            } else {
              const bookPrice = parseFloat(row.item?.paperback?.Price || row.item?.book?.Price || 0);
              const shippingCharges = parseFloat(row.shipping_charges || 0);
              const totalAmount = bookPrice + shippingCharges;
              return totalAmount.toFixed(2) + ' PKR';
            }
          })()
        }</TableCell>
        <TableCell>
          {(() => {
            // Paperback orders - always show status with action buttons
            const deliveryStatus = row.item?.Status || row.item?.Delivery_Status || row.item?.order?.Order_Status || row.item?.paperback_order?.Order_Status || row.item?.order_book?.Status || null;

            if (onUpdateDeliveryStatus) {
              return (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Box
                    sx={{
                      bgcolor: deliveryStatus === 'Delivered' ? "#0E7542" :
                        deliveryStatus === 'Dispatched' ? "#1976d2" :
                          deliveryStatus === 'In Transit' ? "#9c27b0" :
                            deliveryStatus === 'Processing' ? "#ff9800" :
                              deliveryStatus === 'Cancelled' ? "#f44336" : "#FAC85B",
                      textAlign: "center",
                      borderRadius: "3px",
                      color: (deliveryStatus === 'Delivered' || deliveryStatus === 'Dispatched' ||
                        deliveryStatus === 'In Transit' || deliveryStatus === 'Processing' ||
                        deliveryStatus === 'Cancelled') ? "white" : "black",
                      fontSize: "10px",
                      fontFamily: "Montserrat",
                      pt: 1,
                      pb: 1,
                      px: 1
                    }}
                  >
                    <label className="badge-label">
                      {deliveryStatus == null || deliveryStatus === '' ? 'Pending' : deliveryStatus}
                    </label>
                  </Box>
                  {(deliveryStatus == null || deliveryStatus === '' || deliveryStatus === 'Pending') && (
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      sx={{ fontSize: '10px', py: 0.5 }}
                      onClick={() => {
                        console.log('Updating status to Processing for:', row.item);
                        onUpdateDeliveryStatus(row.item, 'Processing');
                      }}
                    >
                      Start Processing
                    </Button>
                  )}
                  {deliveryStatus === 'Processing' && (
                    <Button
                      variant="contained"
                      color="success"
                      size="small"
                      sx={{ fontSize: '10px', py: 0.5 }}
                      onClick={() => {
                        console.log('Updating status to Dispatched for:', row.item);
                        onUpdateDeliveryStatus(row.item, 'Dispatched');
                      }}
                    >
                      Mark as Dispatched
                    </Button>
                  )}
                  {deliveryStatus === 'Dispatched' && (
                    <Button
                      variant="contained"
                      color="info"
                      size="small"
                      sx={{ fontSize: '10px', py: 0.5 }}
                      onClick={() => {
                        console.log('Updating status to In Transit for:', row.item);
                        onUpdateDeliveryStatus(row.item, 'In Transit');
                      }}
                    >
                      Mark as In Transit
                    </Button>
                  )}
                  {deliveryStatus === 'In Transit' && (
                    <Button
                      variant="contained"
                      color="success"
                      size="small"
                      sx={{ fontSize: '10px', py: 0.5 }}
                      onClick={() => {
                        console.log('Updating status to Delivered for:', row.item);
                        onUpdateDeliveryStatus(row.item, 'Delivered');
                      }}
                    >
                      Mark as Delivered
                    </Button>
                  )}
                  {deliveryStatus === 'Delivered' && (
                    <Typography variant="caption" sx={{ color: 'success.main', fontWeight: 'bold', fontSize: '10px' }}>
                      ✓ Delivered
                    </Typography>
                  )}
                  {deliveryStatus === 'Cancelled' && (
                    <Typography variant="caption" sx={{ color: 'error.main', fontWeight: 'bold', fontSize: '10px' }}>
                      ✗ Cancelled
                    </Typography>
                  )}
                </Box>
              );
            } else {
              // Fallback if onUpdateDeliveryStatus is not provided
              return (
                <Box
                  sx={{
                    bgcolor: "#0E7542",
                    textAlign: "center",
                    borderRadius: "3px",
                    color: "white",
                    fontSize: "10px",
                    fontFamily: "Montserrat",
                    pt: 1
                  }}
                >
                  <label className="badge-label">{row.status}</label>
                </Box>
              );
            }
          })()}
        </TableCell>
        <TableCell>
          <Box
            sx={
              {
                bgcolor: `${row.Reference_No == null ? '#FAC85B' : '#0E7542'}`,
                //padding-left: 18px;
                textAlign: "center",
                //padding-right: 5px;
                borderRadius: "3px",
                color: `${row.Reference_No == null ? 'black' : 'white'}`,
                fontSize: "10px",
                fontFamily: "Montserrat",
                pt: 1
              }
            }
          >
            <label className="badge-label">
              {
                row.Reference_No == null ? (
                  'Unpaid'
                ) : (
                  row.Reference_No !== null ? (
                    'Paid'
                  ) : (
                    row.Amount
                  )
                )
              }
            </label>
          </Box>
        </TableCell>
        {/* Shipping columns - always shown for paperback orders */}
        <TableCell>
          {row.shipping_method || '-'}
        </TableCell>
        <TableCell>
          {row.shipping_charges ? row.shipping_charges + ' PKR' : '-'}
        </TableCell>
        <TableCell>
          <div className='actionIcon'>
            <MoreHorizIcon onClick={() => props.onClickActions(row.item)} />
          </div>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
          {/* Colspan: expand icon(1) + orderId(1) + bookDetails(1) + date(1) + amount(1) + status(1) + authorStatus(1) + shipping(2) + action(1) = 9 */}
          <Collapse in={open} timeout="auto" unmountOnExit>
            <TableRow
              sx={{
                [`& .${tableCellClasses.root}`]: {
                  borderBottom: "none",
                },
              }}
            >
              <TableCell><Grid /></TableCell>
              <TableCell>
                {(() => {
                  // Check if this is a grouped order with multiple items
                  const isGroupedOrder = row.item?.items && Array.isArray(row.item.items) && row.item.items.length > 1;

                  // Don't show image for grouped orders (multiple books)
                  if (!isGroupedOrder) {
                    return (
                      <Grid>
                        <img className="sellingHistoryImg" src={row.image} alt="Book" />
                      </Grid>
                    );
                  } else {
                    // For grouped orders, show empty cell or nothing
                    return <Grid></Grid>;
                  }
                })()}
              </TableCell>
              <TableCell>
                <Grid container direction="column">
                  {(() => {
                    // Check if this is a grouped order with multiple items
                    const isGroupedOrder = row.item?.items && Array.isArray(row.item.items) && row.item.items.length > 1;

                    if (isGroupedOrder) {
                      // Display all books in the order
                      return (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, width: '100%' }}>
                          <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1, fontSize: '14px' }}>
                            Books in this Order ({row.item.items.length}):
                          </Typography>
                          {row.item.items.map((item, index) => {
                            const bookData = item?.paperback || item?.book || {};
                            const bookName = bookData?.Name || '';
                            const authorName = bookData?.Author_Name || '';
                            const bookImage = bookData?.Image || '';
                            const quantity = parseInt(item?.quantity || 1);
                            const bookPrice = parseFloat(bookData?.Price || 0);

                            return (
                              <Box
                                key={index}
                                sx={{
                                  p: 1.5,
                                  border: '1px solid #e0e0e0',
                                  borderRadius: '4px',
                                  backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white',
                                  display: 'flex',
                                  gap: 1.5
                                }}
                              >
                                <img
                                  src={bookImage}
                                  alt={bookName}
                                  style={{
                                    width: '50px',
                                    height: '70px',
                                    objectFit: 'cover',
                                    borderRadius: '4px',
                                    flexShrink: 0
                                  }}
                                />
                                <Box sx={{ flex: 1 }}>
                                  <Typography sx={{ fontWeight: "bold", fontSize: '13px', mb: 0.5 }}>
                                    {bookName}
                                  </Typography>
                                  <Typography variant="caption" sx={{ display: 'block', mb: 0.5, color: '#666' }}>
                                    By {authorName}
                                  </Typography>
                                  <Typography variant="caption" sx={{ display: 'block', mb: 0.5 }}>
                                    <strong>Quantity:</strong> {quantity}
                                  </Typography>
                                  <Typography variant="caption" sx={{ display: 'block', fontWeight: 'bold' }}>
                                    <strong>Price:</strong> {bookPrice} PKR {quantity > 1 ? `× ${quantity} = ${(bookPrice * quantity).toFixed(2)} PKR` : ''}
                                  </Typography>
                                </Box>
                              </Box>
                            );
                          })}
                        </Box>
                      );
                    } else {
                      // Single book display (existing logic)
                      return (
                        <>
                          <Typography sx={{ fontWeight: "bold" }}>
                            {row.bookDetails}
                          </Typography>
                          <Typography variant="caption">{`By ${row.author}`}</Typography>
                          <Grid>
                            <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                              Date:{" "}
                            </Typography>
                            <Typography variant="caption">
                              <Moment format="DD-MM-YYYY HH:mm">{row.date}</Moment>
                            </Typography>
                          </Grid>
                        </>
                      );
                    }
                  })()}
                </Grid>
              </TableCell>
              <TableCell>
                <Grid container direction="column">
                  <Grid>
                    <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                      TOTAL:{" "}
                    </Typography>
                    <Typography variant="caption">
                      {
                        (() => {
                          // Paperback - only PKR, include shipping
                          const isGroupedOrder = row.item?.items && Array.isArray(row.item.items) && row.item.items.length > 1;

                          if (isGroupedOrder) {
                            // For grouped orders, calculate total from all items
                            const totalBookAmount = row.item.totalBookAmount || row.item.items.reduce((sum, itm) => {
                              const price = parseFloat(itm?.paperback?.Price || itm?.book?.Price || 0);
                              const quantity = parseInt(itm?.quantity || 1);
                              return sum + (price * quantity);
                            }, 0);
                            const shippingCharges = parseFloat(row.shipping_charges || 0);
                            return (totalBookAmount + shippingCharges).toFixed(2) + ' PKR';
                          } else {
                            const bookPrice = parseFloat(row.item?.paperback?.Price || row.item?.book?.Price || 0);
                            const shippingCharges = parseFloat(row.shipping_charges || 0);
                            return (bookPrice + shippingCharges).toFixed(2) + ' PKR';
                          }
                        })()
                      }
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                      TLBC EARNS:{" "}
                    </Typography>
                    <Typography variant="caption">
                      {
                        (() => {
                          // Paperback - only PKR
                          const isGroupedOrder = row.item?.items && Array.isArray(row.item.items) && row.item.items.length > 1;

                          if (isGroupedOrder) {
                            const totalBookAmount = row.item.totalBookAmount || row.item.items.reduce((sum, itm) => {
                              const price = parseFloat(itm?.paperback?.Price || itm?.book?.Price || 0);
                              const quantity = parseInt(itm?.quantity || 1);
                              return sum + (price * quantity);
                            }, 0);
                            return (totalBookAmount * 0.3).toFixed(2) + ' PKR';
                          } else {
                            const bookPrice = parseFloat(row.item?.paperback?.Price || row.item?.book?.Price || 0);
                            return (bookPrice * 0.3).toFixed(2) + ' PKR';
                          }
                        })()
                      }
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                      AUTHOR EARNS:{" "}
                    </Typography>
                    <Typography variant="caption">
                      {
                        (() => {
                          // Paperback - only PKR
                          const isGroupedOrder = row.item?.items && Array.isArray(row.item.items) && row.item.items.length > 1;

                          if (isGroupedOrder) {
                            const totalBookAmount = row.item.totalBookAmount || row.item.items.reduce((sum, itm) => {
                              const price = parseFloat(itm?.paperback?.Price || itm?.book?.Price || 0);
                              const quantity = parseInt(itm?.quantity || 1);
                              return sum + (price * quantity);
                            }, 0);
                            return (totalBookAmount * 0.7).toFixed(2) + ' PKR';
                          } else {
                            const bookPrice = parseFloat(row.item?.paperback?.Price || row.item?.book?.Price || 0);
                            return (bookPrice * 0.7).toFixed(2) + ' PKR';
                          }
                        })()
                      }
                    </Typography>
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell>
                <Grid container direction="column">
                  {/* <Grid>
                    <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                      TLBC ORDER ID:{" "}
                    </Typography>
                    <Typography variant="caption">{row.stripeID}</Typography>
                  </Grid>
                  <Grid>
                    <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                      TX ID STRIPE:{" "}
                    </Typography>
                    <Typography variant="caption">{row.stripeID}</Typography>
                  </Grid> */}
                  <Grid>
                    <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                      EMAIL:{" "}
                    </Typography>
                    <Typography variant="caption">{row.buyerID}</Typography>
                  </Grid>
                  <Grid>
                    <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                      CLEARING NO:{" "}
                    </Typography>
                    <Typography variant="caption">{row.stripeID}</Typography>
                  </Grid>
                  <Grid>
                    <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                      PAYMENT METHOD:{" "}
                    </Typography>
                    <Typography variant="caption">{row.paymentMethod}</Typography>
                  </Grid>
                </Grid>
              </TableCell>

            </TableRow>
            {/* Customer Details - Always shown for paperback orders */}
            {(
              <TableRow
                sx={{
                  [`& .${tableCellClasses.root}`]: {
                    borderBottom: "none",
                  },
                }}
              >
                <TableCell><Grid /></TableCell>

                <TableCell>
                  <Grid>
                    {/* <img className="sellingHistoryImg" src={row.image}></img> */}
                  </Grid>
                </TableCell>
                <TableCell>
                  <Grid container direction="column">
                    {/* <Typography sx={{ fontWeight: "bold" }}>
                    {row.bookDetails}
                  </Typography>
                  <Typography variant="caption">{`By ${row.author}`}</Typography>
                  <Grid>
                    <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                      Date:{" "}
                    </Typography>
                    <Typography variant="caption">
                      <Moment format="DD-MM-YYYY HH:mm">{row.date}</Moment>
                    </Typography>
                  </Grid> */}
                  </Grid>
                </TableCell>

                <TableCell>
                  <Grid container direction="column">
                    <Grid>
                      <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                        Customer Name:{" "}
                      </Typography>
                      <Typography variant="caption">
                        {
                          row.item?.order?.person_name || row.item?.paperback_order?.person_name || row.item?.order_book?.person_name || '-'
                        }
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                        Customer Mobile:{" "}
                      </Typography>
                      <Typography variant="caption">
                        {
                          row.item?.order?.person_mobile || row.item?.paperback_order?.person_mobile || row.item?.order_book?.person_mobile || '-'
                        }
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                        Customer Comment:{" "}
                      </Typography>
                      <Typography variant="caption">
                        {
                          row.item?.order?.person_comment || row.item?.paperback_order?.person_comment || row.item?.order_book?.person_comment || '-'
                        }
                      </Typography>
                    </Grid>
                  </Grid>
                </TableCell>

                <TableCell>
                  <Grid container direction="column">
                    <Grid>
                      <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                        Customer State:{" "}
                      </Typography>
                      <Typography variant="caption">
                        {
                          row.item?.order?.person_state || row.item?.paperback_order?.person_state || row.item?.order_book?.person_state || '-'
                        }
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                        Customer City:{" "}
                      </Typography>
                      <Typography variant="caption">
                        {
                          row.item?.order?.person_city || row.item?.paperback_order?.person_city || row.item?.order_book?.person_city || '-'
                        }
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                        Customer Address:{" "}
                      </Typography>
                      <Typography variant="caption">
                        {
                          row.item?.order?.person_address || row.item?.paperback_order?.person_address || row.item?.order_book?.person_address || '-'
                        }
                      </Typography>
                    </Grid>
                  </Grid>
                </TableCell>

                <TableCell>
                  <Grid>
                    <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                      Delivery Status:{" "}
                    </Typography>
                    <Typography variant="caption">
                      {(() => {
                        // Get status from multiple possible locations
                        const status = row.item.Status || row.item.Delivery_Status || row.item?.order?.Order_Status || row.item?.paperback_order?.Order_Status || row.item?.order_book?.Status || null;
                        if (status == null || status === '') {
                          return 'Pending';
                        } else {
                          return status;
                        }
                      })()}
                    </Typography>
                  </Grid>
                  {(() => {
                    // Check if this is a paperback order
                    const isPaperback = row.item.type === 'paperback' ||
                      row.item.type === 'PAPERBACK' ||
                      row.item.paperback !== undefined;
                    const status = row.item.Status || row.item.Delivery_Status || row.item?.paperback_order?.Order_Status || row.item?.order_book?.Status || null;

                    if (isPaperback && onUpdateDeliveryStatus) {
                      return (
                        <Grid container direction="column" spacing={1} sx={{ mt: 1 }}>
                          {(status == null || status === '' || status === 'Pending') && (
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              sx={{ mb: 1 }}
                              onClick={() => {
                                console.log('Updating status to Processing for:', row.item);
                                onUpdateDeliveryStatus(row.item, 'Processing');
                              }}
                            >
                              Start Processing
                            </Button>
                          )}
                          {status === 'Processing' && (
                            <Button
                              variant="contained"
                              color="success"
                              size="small"
                              sx={{ mb: 1 }}
                              onClick={() => {
                                console.log('Updating status to Dispatched for:', row.item);
                                onUpdateDeliveryStatus(row.item, 'Dispatched');
                              }}
                            >
                              Mark as Dispatched
                            </Button>
                          )}
                          {status === 'Dispatched' && (
                            <Button
                              variant="contained"
                              color="info"
                              size="small"
                              sx={{ mb: 1 }}
                              onClick={() => {
                                console.log('Updating status to In Transit for:', row.item);
                                onUpdateDeliveryStatus(row.item, 'In Transit');
                              }}
                            >
                              Mark as In Transit
                            </Button>
                          )}
                          {status === 'In Transit' && (
                            <Button
                              variant="contained"
                              color="success"
                              size="small"
                              onClick={() => {
                                console.log('Updating status to Delivered for:', row.item);
                                onUpdateDeliveryStatus(row.item, 'Delivered');
                              }}
                            >
                              Mark as Delivered
                            </Button>
                          )}
                          {status === 'Delivered' && (
                            <Typography variant="caption" sx={{ color: 'success.main', fontWeight: 'bold' }}>
                              ✓ Order Delivered
                            </Typography>
                          )}
                          {status === 'Cancelled' && (
                            <Typography variant="caption" sx={{ color: 'error.main', fontWeight: 'bold' }}>
                              ✗ Order Cancelled
                            </Typography>
                          )}
                        </Grid>
                      );
                    } else {
                      return (
                        <Grid container direction="column">
                          <Button variant="outlined" disabled={row.item.Status == 'DELIVERED' ? true : false}>Deliver</Button>
                        </Grid>
                      );
                    }
                  })()}
                </TableCell>

              </TableRow>
            )}
            {/* Shipping Information - Always shown for paperback orders */}
            {(
              <TableRow
                sx={{
                  [`& .${tableCellClasses.root}`]: {
                    borderBottom: "none",
                  },
                }}
              >
                <TableCell><Grid /></TableCell>
                <TableCell>
                  <Grid>
                    {/* Empty space */}
                  </Grid>
                </TableCell>
                <TableCell>
                  <Grid container direction="column">
                    <Typography variant="caption" sx={{ fontWeight: "bold", fontSize: "12px" }}>
                      Shipping Information
                    </Typography>
                  </Grid>
                </TableCell>
                <TableCell>
                  <Grid container direction="column">
                    <Grid>
                      <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                        Shipping Method:{" "}
                      </Typography>
                      <Typography variant="caption">
                        {row.item?.order?.shipping_method || row.item?.paperback_order?.shipping_method || '-'}
                      </Typography>
                    </Grid>
                    <Grid sx={{ mt: 1 }}>
                      <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                        Shipping Charges:{" "}
                      </Typography>
                      <Typography variant="caption">
                        {(row.item?.order?.shipping_charges || row.item?.paperback_order?.shipping_charges) ? (row.item?.order?.shipping_charges || row.item?.paperback_order?.shipping_charges) + ' PKR' : '-'}
                      </Typography>
                    </Grid>
                    {(row.item?.order?.tracking_id || row.item?.paperback_order?.tracking_id) && (
                      <Grid sx={{ mt: 1 }}>
                        <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                          Tracking ID:{" "}
                        </Typography>
                        <Typography variant="caption">
                          {row.item?.order?.tracking_id || row.item?.paperback_order?.tracking_id}
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                </TableCell>
                <TableCell>
                  <Grid container direction="column">
                    <Grid>
                      <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                        Total Order Amount:{" "}
                      </Typography>
                      <Typography variant="caption">
                        {(() => {
                          const isGroupedOrder = row.item?.items && Array.isArray(row.item.items) && row.item.items.length > 1;

                          if (isGroupedOrder) {
                            // For grouped orders, calculate total from all items
                            const totalBookAmount = row.item.totalBookAmount || row.item.items.reduce((sum, itm) => {
                              const price = parseFloat(itm?.paperback?.Price || itm?.book?.Price || 0);
                              const quantity = parseInt(itm?.quantity || 1);
                              return sum + (price * quantity);
                            }, 0);
                            const shippingCharges = parseFloat(row.item?.order?.shipping_charges || row.item?.paperback_order?.shipping_charges || 0);
                            return (totalBookAmount + shippingCharges).toFixed(2) + ' PKR';
                          } else {
                            const bookPrice = parseFloat(row.item?.paperback?.Price || row.item?.book?.Price || 0);
                            const shippingCharges = parseFloat(row.item?.order?.shipping_charges || row.item?.paperback_order?.shipping_charges || 0);
                            return (bookPrice + shippingCharges).toFixed(2) + ' PKR';
                          }
                        })()}
                      </Typography>
                    </Grid>
                  </Grid>
                </TableCell>
                <TableCell>
                  <Grid>
                    {/* Empty space */}
                  </Grid>
                </TableCell>
                <TableCell>
                  <Grid>
                    {/* Empty space */}
                  </Grid>
                </TableCell>
              </TableRow>
            )}
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    item: PropTypes.objectOf(PropTypes.any).isRequired,
    orderID: PropTypes.string.isRequired,
    bookDetails: PropTypes.string.isRequired,
    date: PropTypes.any.isRequired,
    amount: PropTypes.string.isRequired,
    buyerID: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired,
    stripeID: PropTypes.string.isRequired,
    authorEarns: PropTypes.string.isRequired,
    tlbcEarns: PropTypes.string.isRequired,
    history: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number.isRequired,
        customerId: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
      })
    ).isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    protein: PropTypes.number.isRequired,
  }).isRequired,
};

// const rows = [

//   createData('Frozen yoghurt', 159, 6.0, 24, 4.0, 3.99),
//   createData('Ice cream sandwich', 237, 9.0, 37, 4.3, 4.99),
//   createData('Eclair', 262, 16.0, 24, 6.0, 3.79),
//   createData('Cupcake', 305, 3.7, 67, 4.3, 2.5),
//   createData('Gingerbread', 356, 16.0, 49, 3.9, 1.5),
// ];
function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}
TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default class DataTablePaperback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orderList: [],
      page: 0,
      rowsPerPage: 10,
      startDate: '',
      endDate: '',
      activeTab: 0,
    };
  }

  componentDidMount() {
    this.setState({
      orderList: this.props.orderList,
    });


    console.log('DataTableOrderList', this.props.orderList)
  }
  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 });
  };

  onClickFailed = () => {
    this.props.onClickFailed();
  }
  onClickActions = (item) => {
    console.log(item)
    this.props.onClickActions(item)
  }

  onUpdateDeliveryStatus = (item, status) => {
    if (this.props.onUpdateDeliveryStatus) {
      this.props.onUpdateDeliveryStatus(item, status)
    }
  }

  handleTabChange = (event, newValue) => {
    this.setState({
      activeTab: newValue,
      page: 0 // Reset to first page when changing tabs
    });
  };

  componentDidUpdate = function (prevProps, prevState, snapshot) {
    if (this.props.orderList !== prevProps.orderList) {
      this.setState({
        orderList: this.props.orderList,
      });
    }
  };
  render() {
    const rows = [];
    console.log(this.state.orderList);

    // Filter orders based on active tab
    let filteredOrderList = this.state.orderList;

    if (this.state.activeTab === 1) { // Ebooks tab
      filteredOrderList = this.state.orderList.filter(item =>
        item?.book?.Type === 'Ebook' || item?.book?.Book_Type === 'Ebook' || !item?.book?.Type
      );
    } else if (this.state.activeTab === 2) { // Paperbacks tab
      filteredOrderList = this.state.orderList.filter(item =>
        item?.book?.Type === 'Paperback' || item?.book?.Book_Type === 'Paperback'
      );
    }
    // activeTab === 0 shows all orders

    filteredOrderList.map((item) => {
      // Check if this is a grouped order with multiple items
      const isGroupedOrder = item?.items && Array.isArray(item.items) && item.items.length > 1;

      // For grouped orders, use first item for book details display, but calculate totals for all items
      const displayItem = isGroupedOrder ? item.items[0] : item;
      const bookData = displayItem?.book || displayItem?.paperback || item?.book || item?.paperback || {};
      const bookName = bookData?.Name || '';
      const bookImage = bookData?.Image || '';
      const authorName = bookData?.Author_Name || '';
      const bookPrice = bookData?.Price || 0;
      const bookPriceUSD = bookData?.Price_USD || 0;

      // Get status - check multiple possible locations (new structure: order.Order_Status, old: Status)
      const orderStatus = item?.Status || item?.Delivery_Status || item?.order?.Order_Status || item?.paperback_order?.Order_Status || item?.order_book?.Status || null;

      // Paperback orders - only PKR, no USD/PayPal conversion
      // Get shipping charges from order object (new structure) or paperback_order (old structure)
      const shippingCharges = parseFloat(item?.order?.shipping_charges || item?.paperback_order?.shipping_charges || item?.shipping_charges || 0);

      let calculatedAmount, calculatedTlbcEarns, calculatedAuthorEarns, calculatedCurrency, calculatedDollarRate;

      if (isGroupedOrder) {
        // For grouped orders, calculate total from all items
        const totalBookAmount = item.totalBookAmount || item.items.reduce((sum, itm) => {
          const price = parseFloat(itm?.paperback?.Price || itm?.book?.Price || 0);
          const quantity = parseInt(itm?.quantity || 1);
          return sum + (price * quantity);
        }, 0);
        const totalAmount = totalBookAmount + shippingCharges;
        calculatedAmount = totalAmount.toFixed(2) + " PKR";
        calculatedTlbcEarns = (totalBookAmount * 0.3).toFixed(2) + " PKR";
        calculatedAuthorEarns = (totalBookAmount * 0.7).toFixed(2) + " PKR";
      } else {
        // Single item order
        const totalAmount = parseFloat(bookPrice || 0) + shippingCharges;
        calculatedAmount = totalAmount.toFixed(2) + " PKR";
        calculatedTlbcEarns = (parseFloat(bookPrice || 0) * 0.3).toFixed(2) + " PKR";
        calculatedAuthorEarns = (parseFloat(bookPrice || 0) * 0.7).toFixed(2) + " PKR";
      }
      calculatedCurrency = 'PKR';
      calculatedDollarRate = 1; // Not used for paperbacks

      rows.push(
        createData(
          item,
          item?.Order_ID,
          bookName, // Will be overridden in Row component for grouped orders
          new Date(item?.order?.createdAt?.slice(0, -1) || item?.paperback_order?.createdAt?.slice(0, -1) || item?.order_book?.createdAt?.slice(0, -1) || item?.createdAt || new Date()),
          calculatedAmount,
          item?.order?.Buyer_ID || item?.paperback_order?.Buyer_ID || item?.order_book?.user?.Email || '',
          !item?.order?.Payment_Status && !item?.paperback_order?.Payment_Status && !item?.order_book?.Payment_Status
            ? "Pending"
            : (item?.order?.Payment_Status || item?.paperback_order?.Payment_Status || item?.order_book?.Payment_Status) === "Published"
              ? "Sold"
              : (item?.order?.Payment_Status || item?.paperback_order?.Payment_Status || item?.order_book?.Payment_Status),
          bookImage,
          authorName,
          item?.order?.Reference_No || item?.paperback_order?.Reference_No || item?.order_book?.Reference_No,
          calculatedTlbcEarns,
          calculatedAuthorEarns,
          item?.Status,
          item?.Amount,
          item?.bookAmount,
          item?.clearingAmount,
          calculatedCurrency,
          calculatedDollarRate,
          item?.Reference_No,
          orderStatus, // Use the resolved status
          item?.order?.Payment_Method || item?.paperback_order?.Payment_Method || item?.order_book?.Payment_Method,
          item?.order?.shipping_method || item?.paperback_order?.shipping_method || '', // Shipping method from order
          parseFloat(item?.order?.shipping_charges || item?.paperback_order?.shipping_charges || 0) // Shipping charges from order
        )
      )
    }
    );

    const handleDownload = () => {
      const { orderList, startDate, endDate, activeTab } = this.state;
      if (!startDate || !endDate) {
        alert('Please select a date range.');
        return;
      }

      const start = new Date(startDate);
      const end = new Date(endDate);

      // Filter orders based on selected date range and active tab
      let filteredOrders = orderList.filter((item) => {
        const orderDate = new Date(item?.order_book?.createdAt.slice(0, -1));
        return orderDate >= start && orderDate <= end;
      });

      // Apply tab filtering
      if (activeTab === 1) { // Ebooks tab
        filteredOrders = filteredOrders.filter(item =>
          item?.book?.Type === 'Ebook' || item?.book?.Book_Type === 'Ebook' || !item?.book?.Type
        );
      } else if (activeTab === 2) { // Paperbacks tab
        filteredOrders = filteredOrders.filter(item =>
          item?.book?.Type === 'Paperback' || item?.book?.Book_Type === 'Paperback'
        );
      }

      if (filteredOrders.length === 0) {
        alert('No orders found in the selected date range.');
        return;
      }

      const tabNames = ['All Orders', 'Ebooks', 'Paperbacks'];
      const fileName = `${tabNames[activeTab]}_Orders.xlsx`;

      const rows = filteredOrders.map((item) => {
        // Handle both book (ebook) and paperback data structures
        const bookData = item?.book || item?.paperback || {};
        return {
          Date: new Date(item?.order_book?.createdAt?.slice(0, -1) || item?.createdAt || new Date()).toLocaleDateString(),
          Book_Name: bookData?.Name || '',
          "Author Name": bookData?.Author_Name || '',
          "Publisher": bookData?.Publisher_Name || '',
          "Author ID": bookData?.Author_Email || '',
          "Book Type": bookData?.Type || bookData?.Book_Type || item?.type || 'Unknown',
          "Amount": item?.order_book?.Payment_Method === "PayPal"
            ? (bookData?.Price_USD || 0) * 150 + " Rs."
            : (bookData?.Price || 0) + " Rs.",
          "Buyer ID": item?.order_book?.user?.Email || '',
        };
      });

      // Create a new workbook
      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, tabNames[activeTab]);

      // Convert the workbook to a blob and download
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
      saveAs(data, fileName);
    };

    return (
      <Box>
        <Paper>
          <Grid
            container
            sx={{
              display: "flex",
              p: 3,
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h4">Order History</Typography>
            <div>
              <label>Select Start Date: </label>
              <input
                type="date"
                value={this.state.startDate}
                onChange={(e) => this.setState({ startDate: e.target.value })}
              />
            </div>
            <div>
              <label>Select End Date: </label>
              <input
                type="date"
                value={this.state.endDate}
                onChange={(e) => this.setState({ endDate: e.target.value })}
              />
            </div>
            <button onClick={handleDownload}>Download Orders</button>
            <SearchField
              onChange={this.props.onChange}
              onClickSearch={this.props.onClickSearch}
              onSearch={this.props.onSearch}
              search={this.props.search}
            />
          </Grid>

          <TableContainer>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell>ORDER ID</TableCell>
                  <TableCell>BOOK DETAILS</TableCell>
                  <TableCell>DATE & TIME</TableCell>
                  <TableCell>AMOUNT</TableCell>
                  <TableCell>STATUS</TableCell>
                  <TableCell>AUTHOR STATUS</TableCell>
                  <TableCell>SHIPPING METHOD</TableCell>
                  <TableCell>SHIPPING CHARGES</TableCell>
                  <TableCell>ACTION</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(this.state.rowsPerPage > 0
                  ? rows.slice(
                    this.state.page * this.state.rowsPerPage,
                    this.state.page * this.state.rowsPerPage +
                    this.state.rowsPerPage
                  )
                  : rows
                ).map((row) => (
                  <Row
                    row={row}
                    onClickActions={this.onClickActions}
                    onUpdateDeliveryStatus={this.onUpdateDeliveryStatus}
                  />
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[10, 20, 30, { label: "All", value: -1 }]}
                    sx={{
                      height: '70px',
                      '.MuiTablePagination-select': {
                        paddingTop: '22%'
                      },
                      '.MuiTablePagination-selectIcon': {
                        paddingLeft: '25%',
                        paddingTop: '20%'
                      },
                      "	.MuiTablePagination-input": {
                        fontWeight: "bold",
                        color: "blue"
                      },
                      '.MuiTablePagination-selectLabel': {
                        marginTop: '2%',
                      },
                      '.MuiTablePagination-displayedRows': {
                        marginTop: '2%'
                      }
                    }}
                    count={rows.length}
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
    );
  }
}
